import React from 'react';

interface MetricHeaderProps {
    displayValue: string;
    deltaPct: number;
}

const MetricHeader: React.FC<MetricHeaderProps> = ({ displayValue, deltaPct }) => {
    const isPositive = deltaPct >= 0;

    return (
        <div className="ad-metric-header">
            <span className="ad-metric-value">{displayValue}</span>
            <span className={isPositive ? 'ad-metric-delta ad-metric-delta-up' : 'ad-metric-delta ad-metric-delta-down'}>
                {isPositive ? '↑' : '↓'}
                {Math.abs(deltaPct)}%
            </span>
        </div>
    );
};

export default MetricHeader;
